<template lang="pug">
.blog-item__container
  .col(cols="12")
    p.blog-item__date {{ year }}
    h1.blog-item__title {{ title }}
    img(:src="promo_image.meta ? 'https://nekidaem.ru'+promo_image.meta.download_url : ''").blog-item__head-img
    .blog-item__body.row-container
      .col-10(cols="12" md="10")
        ContentParser(:content="content")
        .blog-item__actions
          a(@click="showNetworks = !showNetworks").blog-item__share
            img(src="~assets/images/svg/icons/share.svg")
          ShareNetworks(v-show="showNetworks" :title="title" :promoImage="promoImage" :description="description")
          a.blog-item__like(@click.prevent="postLike")
            IconBase(icon-name="like").blog-item__like-icon
              IconLike(:fill="like.isLiked ? '#02a5ff' : 'white'")
            span.blog-item__likes {{ likes_count }}
        .blog-item__comments
          h3.blog-item__comments-count {{ comments_count }} {{ commentLabel }}
          template(v-for="comment in comments" :key="comment.id")
            .blog-item__comment(
              :class="comment.level === 1 ? 'blog-item__comment-child' : 'blog-item__comment'"
              )
              img(:src="comment.user_avatar").blog-item__comment-avatar
              .blog-item__comment-body
                .blog-item__comment-header
                  span.blog-item__comment-name {{ comment.user_name }}
                  span.blog-item__comment-date {{ comment.submit_date }}
                p.blog-item__comment-text {{ comment.comment }}
                a.blog-item__comment-reply-btn(v-if="comment.allow_reply" @click.prevent="onReply(comment.id)" v-on:click="updateReplyCommentState()") Ответить
            form(@submit.prevent="postFormReplyData()" v-if="comment.allow_reply && replyForm.reply_to===comment.id && !reply_comment.isReplyCommentSent").comment-form.comment-form__reply
              p.comment-form__title Ваш ответ
              input(type="text" placeholder="Ваше имя*" v-model="replyForm.name" :ref="`reply_name`" required="true").base-input.comment-form__input
              br
              input(type="email" placeholder="Ваш email*" v-model="replyForm.email" required="true").base-input.comment-form__input
              .comment-form__main
                textarea(placeholder="Здесь вы можете оставить комментарий" v-model="replyForm.comment" required="true").comment-form__text
              BaseBtn.comment-form__submit Ответить
            div(v-show="reply_comment.isReplyCommentSent && comment.id === reply_comment.commentId").comment-form__reply-message
              h3.comment-form__submitted Спасибо за комментарий!
              p.comment-form__submitted Вам на почту отправлено сообщение для его подтверждения.
        form(@submit.prevent="postFormCommentData()").comment-form
          p.comment-form__title Ваш комментарий
          input(type="text" placeholder="Ваше имя*" @focus="clearOnReply" v-model="commentForm.name" ref="comment_name" required="true").base-input.comment-form__input
          br
          input(type="email" placeholder="Ваш email*" @focus="clearOnReply" v-model="commentForm.email" required="true").base-input.comment-form__input
          .comment-form__main
            .comment-form__avatar
            textarea(placeholder="Здесь вы можете оставить комментарий" @focus="clearOnReply" v-model="commentForm.comment" required="true").comment-form__text
          BaseBtn.comment-form__submit Оставить комментарий
        div(v-if="is_comment_sent").comment-form__submitted-message
          h2.comment-form__submitted Спасибо за комментарий!
          p.comment-form__submitted Вам на почту отправлено сообщение для его подтверждения.

  div(:class="cookie_warning ? 'cookie-warning cookie-warning_active' : 'cookie-warning'")
    p.cookie-warning__message {{ cookie_status.message }}
    .cookie-warning__buttons
      BaseBtn(@click.native="acceptCookie").cookie-warning__button Понял
      BaseBtn(@click.native="cookie_warning=false").cookie-warning__button Позже
  .col
    BaseFooter(:formValue="footer_data")
</template>

<script>
import IconBase from '~/components/IconBase'
import IconLike from '~/components/icons/IconLike'
import { chooseWordEnding } from '~/helpers/chooseWordEnding'
import ShareNetworks from '~/components/ShareNetworks'

import { mapState, mapActions } from "pinia"
import { useBlogStore } from "~~/stores/blog"

export default {
  components: {
    IconBase,
    IconLike,
    ShareNetworks
  },
  data() {
    return {
      commentForm: {
        name: '',
        email: '',
        comment: '',
        reply_to: 0,
        recaptcha: ''
      },
      replyForm: {
        name: '',
        email: '',
        comment: '',
        reply_to: 0,
        recaptcha: ''
      },
      cookie_warning: false,
      showNetworks: false,
      promoImage: '',
      description: '',
    }
  },
  computed: {
    ...mapState(useBlogStore, ['title', 'id', 'year', 'footer_data', 'meta', 'og', 'likes_count', 'comments_count', 'promo_image', 'content', 'comments', 'is_comment_sent', 'reply_comment', 'cookie_status', 'like']),
    commentLabel: function () {
      return chooseWordEnding(this.comments_count, ['Комментарий', 'Комментария', 'Комментариев'])
    }
  },
  watch: {
    is_comment_sent: function () {
      this.commentForm = {
        name: '',
        email: '',
        comment: '',
        reply_to: 0,
      }
    }
  },
  async mounted() {
    await this.checkCookies()
    await this.getUserLike()
    this.cookie_warning = window.localStorage.getItem('cookie_warning') === 'accepted' ? false : true
    this.getShareInfo()
  },
  methods: {
    ...mapActions(useBlogStore, ['postComment', 'postLike', 'checkCookies', 'getUserLike', 'setSlugPage', 'resetState', 'setIsReplyCommentSent']),
    clearOnReply() {
      this.replyForm.name = ''
      this.replyForm.email = ''
      this.replyForm.comment = ''
      this.replyForm.reply_to = 0
      this.replyForm.recaptcha = ''
    },
    onReply(id) {
      this.clearOnReply()
      this.replyForm.reply_to = id
      setTimeout(() => this.$refs[`reply_name`][0].focus(), 100)
    },
    acceptCookie() {
      this.cookie_warning = false
      window.localStorage.setItem('cookie_warning', 'accepted')
    },
    updateReplyCommentState() {
      this.setIsReplyCommentSent({ isReplyCommentSent: false, commentId: null })
    },
    getShareInfo() {
      let item = this.content.find((item) => item.type === 'paragraph')
      this.description = item?.value.split('>')[1].split('<')[0]
      this.promoImage = 'https://nekidaem.ru' + this.promo_image?.meta?.download_url
    },
    async postFormCommentData() {
      const token = await this.recaptchaFn()
      this.commentForm.recaptcha = token.value
      this.postComment(this.commentForm)
    },
    async postFormReplyData() {
      const token = await this.recaptchaFn()
      this.replyForm.recaptcha = token.value
      this.postComment(this.replyForm)
    },
  },
}
</script>

<script setup>
import { storeToRefs } from 'pinia'

const route = useRoute()
const page_slug = route.params.slug
const blogStore = useBlogStore()
await blogStore.setSlugPage(page_slug)

const { meta, og } = storeToRefs(blogStore)
usePageHeadMeta(meta.value.title, meta.value.description, og.value)

const { recaptcha: recaptchaFn } = useVueRecaptcha()
</script>

<style lang="scss">
.blog-item__body {

  .wagtail-titled-paragraphs-title>p,
  .wagtail-titled-paragraph-body {
    color: var(--dark1-color);
  }

  .wagtail-titled-paragraph-body ol {
    padding-left: 1rem;
  }

  .wagtail-titled-paragraph-body ol>li {
    list-style-type: decimal;
    margin-bottom: 1rem;
  }
}
</style>

<style lang="scss" scoped>
.blog-item {

  &__container {
    @media (--small-range-viewport) {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    @media (--complex-screen) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__date {
    color: var(--main-color);
  }

  &__title {
    color: var(--main-color);
    margin-bottom: 75px;
  }

  &__head-img {
    width: 100%;
    margin-bottom: 70px;
    max-height: 520px;
    object-fit: cover;
    object-position: 50% 50%;
  }

  &__body {
    display: flex;
    justify-content: center;
  }

  &__content {
    margin-bottom: 40px;
  }

  &__actions {
    margin-bottom: 60px;
  }

  &__share {
    cursor: pointer;
    margin-right: 15px;
    position: relative;
    bottom: 4px;
  }

  &__like {
    cursor: pointer;
    text-decoration: none;
    color: var(--main-color);
  }

  &__likes {
    font-size: 13px;
  }

  &__like-icon {
    margin-right: 5px;
  }

  &__comments-count {
    color: var(--dark-color);
    text-transform: uppercase;
    margin-bottom: 50px;
  }

  &__comment {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
  }

  &__comment-avatar {
    min-width: 62px;
    height: 62px;
    display: block;
    margin-right: 32px;
    border-radius: 50%;
    background-color: #c4c4c4;
  }

  &__comment-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 105px;
  }

  &__comment-header {
    width: 100%;
    margin-bottom: 10px;
  }

  &__comment-name {
    display: inline-block;
    margin-right: 10px;
    color: var(--dark-color);
    font-size: 16px;
    font-weight: bold;
  }

  &__comment-date {
    color: var(--grey-color);
    font-size: 13px;
  }

  &__comment-text {
    margin-bottom: 15px;
    width: 100%;
    color: var(--dark-color);
  }

  &__comment-reply-btn {
    color: var(--main-color);
    font-size: 13px;
    cursor: pointer;

    &:hover {
      color: var(--purple-color);
    }
  }

  &__comment-child {
    padding-left: 94px;

    .blog-item__comment-text {
      font-size: 13px;
    }
  }
}

.comment-form {
  width: 100%;

  &__title,
  &__input,
  &__submit {

    @media (--extra-samll-viewport-mf) {
      margin-left: 92px;
    }
  }

  &__title {
    color: var(--main-color);
    font-weight: bold;
    margin-bottom: 20px;
  }

  &__input {
    max-width: 335px;
    width: 100%;
    margin-bottom: 25px;
    font-size: 13px;
  }

  &__main {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 35px;

    @media (--extra-samll-viewport-mf) {
      flex-direction: row;
      margin-bottom: 35px;
    }
  }

  &__avatar {
    width: 62px;
    height: 62px;
    background-color: #c4c4c4;
    border: 1px solid var(--grey-color);
    border-radius: 50%;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;

    @media (--extra-samll-viewport-mf) {
      margin-bottom: 0;
    }
  }

  &__text {
    flex-grow: 1;
    min-height: 100px;
    font-size: 13px;
    border: 1px solid var(--grey-color);
    padding: 8px 13px;
    color: var(--dark-color);

    &::placeholder {
      color: var(--grey-color);
    }
  }

  &__reply {
    margin-bottom: 40px;

    @media (--extra-samll-viewport-mf) {
      .comment-form__text {
        margin-left: 92px;
      }
    }
  }

  &__submitted {
    color: var(--main-color);

    @include mobile {
      text-align: center;
    }
  }

  &__reply-message {
    padding-bottom: 20px;
    padding-left: 90px;
  }

  &__submitted-message {
    padding-top: 40px;
    padding-left: 90px;
  }
}

.cookie-warning {
  width: 100%;
  height: 80px;
  background-color: var(--dark-color);
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  visibility: hidden;
  z-index: 444;

  @media screen and (width <=799px) {
    justify-content: flex-start;
  }

  &__message {
    color: #fff;
    font-size: 18px;
    margin-bottom: 0;

    @media screen and (width <=799px) {
      font-size: 16px;
      max-width: 65vw;
    }

    @media screen and (width <=520px) {
      margin-left: 15px;
    }

    @media screen and (521px <=width <=799px) {
      margin-left: 25px;
    }

    @media screen and (800px <=width <=900px) {
      margin-left: 15px;
      margin-right: 10px;
      font-size: 16px;
    }
  }

  &__buttons {
    @media screen and (width <=799px) {
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .cookie-warning__button {
      margin-right: 20px;
      position: relative;
      z-index: 666;

      @media screen and (width <=799px) {
        width: 30vw;
        padding: 11px;
        margin-right: 0px;
      }
    }
  }

  &_active {
    visibility: visible;
  }
}
</style>
